module.exports = __webpack_public_path__ + "img/Marcomm.bde03b60.svg";